import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { inject, Injectable } from '@angular/core';
import { ReportBugModalComponent } from '../components/modals/report-bug-modal/report-bug-modal.component';
import { ConfirmModalComponent } from '../components/modals/confirm-modal/confirm-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { JobService } from './job.service';
import { Store } from '@ngrx/store';
import { JobsActions } from '../store/jobs/jobs.actions';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private dialog: Dialog = inject(Dialog);
  private translateService: TranslateService = inject(TranslateService);
  private jobService: JobService = inject(JobService);
  private store: Store = inject(Store);
  private router: Router = inject(Router);

  openReportModal(): void {
    const dialogRef: DialogRef<unknown, ReportBugModalComponent> =
      this.dialog.open(ReportBugModalComponent, {
        width: '500px',
      });
    const reportBugModal =
      dialogRef.componentInstance as ReportBugModalComponent;
    reportBugModal.send.subscribe(() => {
      dialogRef.close();
    });
    reportBugModal.cancel.subscribe(() => {
      dialogRef.close();
    });
  }

  openDeleteJobModal(jobId: number): void {
    const dialogRef: DialogRef<unknown, ConfirmModalComponent> =
      this.dialog.open(ConfirmModalComponent, {
        width: '500px',
      });
    const confirmModalComponent =
      dialogRef.componentInstance as ConfirmModalComponent;
    confirmModalComponent.content = this.translateService.instant(
      'modal.delete_job.content'
    );
    confirmModalComponent.confirm = this.translateService.instant(
      'modal.delete_job.confirm'
    );
    confirmModalComponent.onConfirm.subscribe(() => {
      this.jobService.delete(jobId).subscribe({
        next: () => {
          if (this.router.url !== '/dashboard/job/') {
            this.router.navigate(['/dashboard/my-jobs']);
          }
          this.store.dispatch(JobsActions.removeJob({ jobId }));
        },
      });
      dialogRef.close();
    });
  }
}
